import gql from 'graphql-tag';

export const conversationOriginFacetFragment = gql`
  fragment conversationOriginFacetFragment on ConversationOriginFacet {
    dokkioClass
    count
    conversationOrigin
  }
`;
export default conversationOriginFacetFragment;
